import Faq from './Faq';

export { Faq };
export default Faq;
